"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessMyLicenceResponseCommand = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var DrivingLicenceStateEnum_1 = require("../../../enums/DrivingLicenceStateEnum");
var ProcessMyLicenceResponseCommand = /** @class */ (function (_super) {
    __extends(ProcessMyLicenceResponseCommand, _super);
    function ProcessMyLicenceResponseCommand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MODAL_FIELD_IN_UI_STATE = "uistate.shouldShowDrivingLicenceNotFoundModal";
        _this.DRIVING_LICENCE_VERIFICATION_STATE_IN_UI_STATE = "uistate.drivingLicenceState";
        return _this;
    }
    ProcessMyLicenceResponseCommand.prototype.exec = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var driverPerson;
            return __generator(this, function (_a) {
                this.guardSettingsProvided(props.journeyEventDefinition.settings);
                driverPerson = this.getDriverPerson(props);
                if (!driverPerson.drivingLicenceHandy) {
                    return [2 /*return*/, Promise.resolve({})];
                }
                if (driverPerson.dlnLookupData.dlnLookupCallSucess) {
                    void props.engine.navigate(this.successPage, false);
                }
                else if (driverPerson.dlnLookupData.shouldPromoteLookupRetry) {
                    props.updateInteraction(true, this.MODAL_FIELD_IN_UI_STATE);
                }
                else {
                    this.resetLicenceType(props);
                    props.updateInteraction(DrivingLicenceStateEnum_1.DrivingLicenceStateEnum.MANUAL_INPUT, this.DRIVING_LICENCE_VERIFICATION_STATE_IN_UI_STATE);
                    void props.engine.navigate(this.failurePage, false);
                }
                return [2 /*return*/, Promise.resolve({})];
            });
        });
    };
    ProcessMyLicenceResponseCommand.prototype.guardSettingsProvided = function (commandSettings) {
        if (!commandSettings) {
            throw new Error("Settings should be provided!");
        }
        this.failurePage = this.getSetting("failurePage", commandSettings);
        if (!this.failurePage) {
            throw new Error("Setting 'failurePage' should be provided!");
        }
        this.successPage = this.getSetting("successPage", commandSettings);
        if (!this.successPage) {
            throw new Error("Setting 'successPage' should be provided!");
        }
    };
    ProcessMyLicenceResponseCommand.prototype.getDriverPerson = function (props) {
        var additionalDriverIndex = this.getSetting("additionalDriverIndex", props.journeyEventDefinition.settings);
        var interaction = props.engine.getInteraction();
        var driverPerson = (additionalDriverIndex !== undefined && additionalDriverIndex !== null)
            ? interaction.additionalDrivers[additionalDriverIndex]
            : interaction.policyHolder;
        if (!driverPerson) {
            throw new Error("Driver could not be retrieved!");
        }
        return {
            drivingLicenceHandy: this.parseBoolean(driverPerson.drivingLicenceHandy),
            dlnLookupData: {
                dlnLookupCallSucess: this.parseBoolean(driverPerson.dlnLookupData.dlnLookupCallSucess),
                dlnLookupResponseHasError: this.parseBoolean(driverPerson.dlnLookupData.dlnLookupResponseHasError),
                shouldPromoteLookupRetry: this.parseBoolean(driverPerson.dlnLookupData.shouldPromoteLookupRetry)
            }
        };
    };
    ProcessMyLicenceResponseCommand.prototype.resetLicenceType = function (props) {
        var additionalDriverIndex = this.getSetting("additionalDriverIndex", props.journeyEventDefinition.settings);
        var licenceTypeField = (additionalDriverIndex !== undefined && additionalDriverIndex !== null)
            ? "additionalDrivers[".concat(additionalDriverIndex, "].licence.type")
            : "policyHolder.licence.type";
        props.updateInteraction(null, licenceTypeField);
    };
    ProcessMyLicenceResponseCommand.prototype.parseBoolean = function (value) {
        if (typeof value === "string") {
            return value === "true";
        }
        else {
            return !!value;
        }
    };
    ProcessMyLicenceResponseCommand = __decorate([
        (0, journey_model_1.settings)([
            { name: "failurePage", type: journey_model_1.TypeDescriptions.String },
            { name: "successPage", type: journey_model_1.TypeDescriptions.String },
            { name: "additionalDriverIndex", type: journey_model_1.TypeDescriptions.Number }
        ])
    ], ProcessMyLicenceResponseCommand);
    return ProcessMyLicenceResponseCommand;
}(plugin_journey_1.JourneyCommandBase));
exports.ProcessMyLicenceResponseCommand = ProcessMyLicenceResponseCommand;
//# sourceMappingURL=ProcessMyLicenceResponseCommand.js.map